import posthog from "posthog-js";

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ??
  "https://us.i.posthog.com";

export function initPostHog() {
  if (!posthogKey) {
    return;
  }
  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageview: false, // We manually capture pageviews via React Router
    person_profiles: "identified_only",
  });
}

export { posthog };
